/* eslint-disable multiline-ternary */
import React from 'react'
import { Box, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { Done } from '@mui/icons-material'

const useStyles = makeStyles(
  ({ spacing, palette, typography, breakpoints }) => {
    const smallPage = 400

    return {
      circle: ({ active }) => ({
        borderRadius: '50%',
        width: 34,
        height: 34,
        background: active ? palette.primary.main : palette.grey.shade[40],
        color: '#fff',
        textAlign: 'center',
        lineHeight: '34px',
        marginRight: 14,
        [breakpoints.down('sm')]: {
          marginRight: 8
        },
        [breakpoints.down(smallPage)]: {
          width: 25,
          height: 25,
          lineHeight: '25px',
          marginRight: 3
        }
      }),
      name: ({ active }) => ({
        ...typography.body.m,
        fontWeight: active
          ? typography.fontWeightMedium
          : typography.fontWeightRegular,
        color: active ? palette.grey.shade[90] : palette.grey.shade[40],
        [breakpoints.down(smallPage)]: {
          ...typography.body.xs
        }
      }),
      icon: {
        verticalAlign: 'text-bottom'
      }
    }
  }
)

const Step = props => {
  const classes = useStyles(props)
  const {
    index,
    label,
    active,
    complete,
    'data-test': testAttr,
    ...rest
  } = props
  return (
    <Box
      display='flex'
      sx={{ px: 1.25 }}
      alignItems='center'
      flexDirection='row'
      {...rest}
    >
      <Typography data-test={`${testAttr}-state`} className={classes.circle}>
        <span>
          {complete ? (
            <Done fontSize='small' className={classes.icon} />
          ) : (
            index
          )}
        </span>
      </Typography>
      <Typography data-test={`${testAttr}-label`} className={classes.name}>
        {label}
      </Typography>
    </Box>
  )
}

export default Step
